import { render, staticRenderFns } from "./TemplateRow.vue?vue&type=template&id=1186f5b2&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateRow.vue?vue&type=script&lang=js&"
export * from "./TemplateRow.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-row.scss?vue&type=style&index=0&id=1186f5b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186f5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1186f5b2')) {
      api.createRecord('1186f5b2', component.options)
    } else {
      api.reload('1186f5b2', component.options)
    }
    module.hot.accept("./TemplateRow.vue?vue&type=template&id=1186f5b2&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('1186f5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateRow.vue"
export default component.exports